import { useNavigate } from "react-router-dom";
import { applyInfo, festivalInfo } from "@/mocks/festival";

export default function ApplySection() {
  const navigate = useNavigate();

  return (
    <section id="apply" className="relative w-full overflow-hidden px-4 md:px-8 py-16 md:py-24 bg-gradient-animate-dark">
      <div className="pointer-events-none absolute -right-24 -top-16 h-72 w-72 rounded-full border border-white/10 animate-floaty-slow"></div>
      <div className="pointer-events-none absolute left-[-6%] bottom-[-10%] h-72 w-72 rounded-full bg-accent-500/20 blur-3xl"></div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="reveal">
          <span className="text-xs tracking-[0.24em] text-accent-300">ADVANCE BOOKING</span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-white">
            거봉포도 수확체험
            <br />
            사전신청 안내
          </h2>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200">
            입장의 거봉포도를 밭에서 직접 수확해 보세요. 수확체험은 회차별 사전신청으로 운영되며,
            신청한 회차에 맞춰 현장에서 체험을 진행합니다.
          </p>

          <dl className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="rounded-lg bg-white/5 border border-white/10 px-5 py-4">
              <dt className="text-xs tracking-[0.16em] text-accent-300">운영 일시</dt>
              <dd className="mt-2 text-sm text-white">{festivalInfo.dateText}</dd>
            </div>
            <div className="rounded-lg bg-white/5 border border-white/10 px-5 py-4">
              <dt className="text-xs tracking-[0.16em] text-accent-300">운영 회차</dt>
              <dd className="mt-2 text-sm text-white">{applyInfo.rounds.join(" / ")}</dd>
            </div>
            <div className="rounded-lg bg-white/5 border border-white/10 px-5 py-4">
              <dt className="text-xs tracking-[0.16em] text-accent-300">체험 장소</dt>
              <dd className="mt-2 text-sm text-white">{festivalInfo.venue}</dd>
            </div>
            <div className="rounded-lg bg-white/5 border border-white/10 px-5 py-4">
              <dt className="text-xs tracking-[0.16em] text-accent-300">참가 정원</dt>
              <dd className="mt-2 text-sm text-white">{applyInfo.capacity}</dd>
            </div>
          </dl>

          <button
            type="button"
            onClick={() => navigate("/apply")}
            className="mt-8 cursor-pointer inline-flex items-center gap-2 whitespace-nowrap rounded-full btn-gradient-accent px-7 py-3.5 text-sm md:text-base font-medium text-white"
          >
            <i className="ri-plant-line"></i>수확체험 신청하기
          </button>
        </div>

        <div className="reveal reveal-delay-2">
          <div className="w-full aspect-[4/3] overflow-hidden rounded-lg">
            <img
              src={applyInfo.image.src}
              alt={applyInfo.image.alt}
              width={1100}
              height={780}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <p className="mt-3 text-xs text-background-300">
            * 체험 회차와 인원은 축제 운영 상황에 따라 조정될 수 있습니다.
          </p>
        </div>
      </div>
    </section>
  );
}